import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { installGlobalErrorHandlers, RootErrorBoundary } from './app/error/index.js';
import { AppProviders } from './app/providers/index.js';
import { RouterProvider } from './app/router/index.js';
import { UnsupportedMobilePage } from './pages/unsupported-mobile/UnsupportedMobilePage.js';
import { ANALYTICS_EVENTS, analytics, initSentry } from './shared/index.js';
import { isMobileBrowser } from './shared/lib/device/isMobileDevice.js';
import './app/styles/tailwind.css';

// Initialize Sentry first to capture all errors
initSentry();

// Install global error handlers before rendering
installGlobalErrorHandlers();
void analytics.track({
  name: ANALYTICS_EVENTS.copilot.appLoaded,
  context: { actor: 'clinician' },
});

const rootElement = document.getElementById('root');
if (rootElement === null) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <RootErrorBoundary>
      {isMobileBrowser() ? (
        <UnsupportedMobilePage />
      ) : (
        <AppProviders>
          <RouterProvider />
        </AppProviders>
      )}
    </RootErrorBoundary>
  </StrictMode>
);
